import Vue from 'vue'
import store from '../store'
import linkifyHtml from 'linkifyjs/html'
import domainRegex from 'domain-regex'
import punyCode from 'punycode'
///////////////////////////////////////////////////////////////////////////////
// вспомогательные функции
///////////////////////////////////////////////////////////////////////////////
const Helper = {
	//=========================================================================
	// javascript Object => FormData
	//=========================================================================
	toFormData: function(obj, form, namespace) {
		let fd = form || new FormData()
		let formKey

		for (let property in obj)
		{
			if (obj.hasOwnProperty(property) && (obj[property] !== undefined && obj[property] !== null))
			{
				if (namespace)
				{
					formKey = namespace + '[' + property + ']'
				}
				else
				{
					formKey = property
				}

				// if the property is an object, but not a File, use recursivity.
				if (obj[property] instanceof Date)
				{
					fd.append(formKey, obj[property].toISOString())
				}
				else if (typeof obj[property] === 'object' && !(obj[property] instanceof File))
				{
					this.toFormData(obj[property], fd, formKey)
				}
				else
				{
					// if it's a string or a File object
					fd.append(formKey, obj[property])
				}
			}
		}

		return fd
	},

	//=========================================================================
	// сортировка свойств объекта => массив
	//=========================================================================
	sortByProp: function(row, sortName = 'order', needGenerate = false, model = false) {
		// переменные
		let newRow = []
		let num = 0
		let tmp
		let _deletedFields = []

		let _genNum = 0

		// формируем отсортированный массив
		for (var field in row) if (row.hasOwnProperty(field))
		{
			// игнорим поля для удаленя файлов или картинок
			if (/_delete$/i.test(field) && model !== 'TicketMessageUpdateForm')
			{
				// просто запоминаем их в массив
				_deletedFields.push(field)
				continue
			}

			// готовим копию объекта
			tmp = row[field]
			// добавляем новые свойства (наблюдаемые)
			Vue.set(tmp, '_field_name', field)
			Vue.set(tmp, '_errMsg', '')
			Vue.set(tmp, '_visible', true)
			Vue.set(tmp, '_visibleRowNumber', 0)

			// если здана генерация индекса
			if (needGenerate === true)
				Vue.set(tmp, sortName, _genNum++)

			// если у поля нет сортировки - пихаем их все в нулевой элемент
			if (!(sortName in row[field]) || !row[field][sortName])
			{
				// частный случай
				if (field === 'cps_email' && row[field]['type'] === 'email')
				{
					if (newRow[1] === undefined) newRow[1] = []
					newRow[1].push(tmp)
				}
				else
				{
					if (newRow[0] === undefined) newRow[0] = []
					newRow[0].push(tmp)
				}
			}
			// у поля есть сортировка
			else
			{
				// получим номер сортировки
				num = row[field][sortName]
				if (newRow[num] === undefined) newRow[num] = []
				newRow[num].push(tmp)
			}
		}

		// в каждом элементе расставим: количество элементов в одной строке,
		// и признак того что значение можно удалить
		let _rowNum = 1
		let _isVisible = false
		for (let k = 0; k < newRow.length; k++)
		{
			// по умолчанию считаем что строка не видима
			_isVisible = false

			if (newRow[k])
			{
				for (let l = 0; l < newRow[k].length; l++)
				{
					// количество полей в строке
					newRow[k][l]['_row_count'] = newRow[k].length
					// добавим поле для удаления файла
					if (_deletedFields.indexOf(newRow[k][l]['_field_name'] + '_delete') > -1) Vue.set(newRow[k][l], '_canDelete', true)

					// нормализуем начальное значение для логических полей
					if (newRow[k][l]['type'] === 'boolean')
					{
						if ('value' in newRow[k][l]) newRow[k][l]['_oldValue'] = this.normalizeBooleanValue(newRow[k][l]['value'])
						else newRow[k][l]['_oldValue'] = false
					}

					// если есть хоть одно не скрытое поле - строка видима
					if (newRow[k][l]['type'] !== 'hidden') _isVisible = true
				}

				// рассмотрим строки с одним числовым полем
				if (newRow[k].length === 1 && (newRow[k][0]['type'] === 'money' || newRow[k][0]['type'] === 'float' || newRow[k][0]['type'] === 'int' || newRow[k][0]['type'] === 'integer'))
				{
					newRow[k][0]['_row_count'] = 4
					// добавим фековое поле, для того что бы браузер рассчитал ширину числовго поля (уменьшим его)
					for (let _i = 1; _i < 4; _i++)
					{
						newRow[k].push({
							'type': 'fake',
							'title': '',
							'readonly': true,
							'order': newRow[k][0].order,
							'_field_name': 'fake_' + k + '_' + _i,
							'_visible': true,
							'_row_count': 4
						})
					}
				}

				// порядковый номер строки - только из видимых
				newRow[k][0]['_visibleRowNumber'] = _rowNum
				if (_isVisible) _rowNum++
			}
		}

		return newRow
	},

	//=========================================================================
	// функция - ставит признак невидимости фейковым полям
	//=========================================================================
	hideFakeFields: function(fields) {
		fields.forEach(row => {
			if (row && Array.isArray(row) && row.length)
			{
				row.forEach(field => {
					if (field && field.type === 'fake')
					{
						field._visible = false
					}
				})
			}
		})
	},

	//=========================================================================
	// функция - время в секундах с 01.01.1970, так сказать UNIX timestamp.
	//=========================================================================
	unixTime: function(ext) {
		if (ext) return (new Date()).getTime()
		else return Math.floor((new Date()).getTime() / 1000)
	},

	//=========================================================================
	// преобразование по словарю
	//=========================================================================
	localeFtc: function(str) {
		// проверка входного параметра
		if (str === null || str === undefined || str === '') return ''

		// приведение к типу String и разбивка на части и подстановка данных из словаря
		return String(str).split(' ').map(function(s) {
			// находим паттерн
			let m = s.match(/\w+\/\w+/)
			// если нашли
			if (m !== null) return m in Vue.localeBase && Vue.localeBase[m] ? s.replace(m, Vue.localeBase[m]) : s
			// если не нашли
			return s in Vue.localeBase && Vue.localeBase[s] ? Vue.localeBase[s] : s
		}).join(' ')
	},

	//=========================================================================
	// применяет все заданные методы
	//=========================================================================
	methodsToValue: function(value, methods) {
		let _value = value

		if (methods && Array.isArray(methods))
		{
			if (methods.indexOf('ftc') >= 0) _value = this.localeFtc(_value)
			if (methods.indexOf('lower') >= 0)
			{
				if (_value !== 'PKH')
					_value = _value.toLowerCase()
			}
		}

		return _value
	},

	//=========================================================================
	// просто возвращает значение с обработкой
	//=========================================================================
	cellValue: function(field, row, raw, methods) {
		if (row[field] === null || row[field] === undefined) return ''
		let _value = row[field]
		return this.methodsToValue(_value, methods)
	},

	//=========================================================================
	// формирует статус для List
	//=========================================================================
	cellStatus: function(field, row, raw) {
		// формируем поле расширенного статуса
		let _extField = field + '_text'
		// укажем для частных случаев
		if (field === 'service_status') _extField = 'service_status_text'

		// готовим ответ
		let _answer = {
			'loader': false,
			'timer': false,
			'status': ''
		}

		// сначала проверяем расширенный статус
		if (row[_extField])
		{
			// значение расширенного статуса
			let _extValue = row[_extField].replace('request/status_processing', '').trim()

			// по умолчанию считаем что это проецсс
			_answer['status'] = this.localeFtc(_extValue).toLowerCase()
			_answer['loader'] = true

			// если это очередь
			if (_extValue.indexOf('request/status_queue') > -1)
			{
				_extValue = _extValue.replace('request/status_queue', '').trim()
				_answer['status'] = this.localeFtc(_extValue).toLowerCase()
				_answer['loader'] = false
				_answer['timer'] = true
			}

			return _answer
		}

		// расширенный статус пуст - смотрим на стандартный статус
		if (row[field] === null || row[field] === undefined)
		{
			_answer['status'] = 'unknown'
			return _answer
		}
		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list'])
		{
			_answer['status'] = row[field]
			return _answer
		}

		// есть список и есть значение
		let _list = raw['filters'][field]['list']

		if (typeof _list === 'object' && row[field] in _list)
			_answer['status'] = raw['filters'][field]['list'][row[field]]
		else
			_answer['status'] = 'unknown'

		_answer['status'] = this.localeFtc(_answer['status']).toLowerCase()

		// для отдельных случаев требуется лоадер
		if (row[field] === 'processing') _answer['loader'] = true

		return _answer
	},

	//=========================================================================
	// формирует статус для View
	//=========================================================================
	cellStatusInView: function(raw) {
		// определим поля
		let _field = 'value'
		let _extField = 'text'

		// готовим ответ
		let _answer = {
			'loader': false,
			'timer': false,
			'status': ''
		}

		// сначала проверяем расширенный статус
		if (raw[_extField])
		{
			// значение расширенного статуса
			let _extValue = raw[_extField].replace('request/status_processing', '').trim()

			// по умолчанию считаем что это проецсс
			_answer['status'] = this.localeFtc(_extValue).toLowerCase()
			_answer['loader'] = true

			// если это очередь
			if (_extValue.indexOf('request/status_queue') > -1)
			{
				_extValue = _extValue.replace('request/status_queue', '').trim()
				_answer['status'] = this.localeFtc(_extValue).toLowerCase()
				_answer['loader'] = false
				_answer['timer'] = true
			}

			return _answer
		}

		// расширенный статус пуст - смотрим на стандартный статус
		if (raw[_field] === null || raw[_field] === undefined)
		{
			_answer['status'] = 'unknown'
			return _answer
		}

		// по умолачанию - передаем как есть
		_answer['status'] = raw[_field]

		// если нет списка, или значения в списке
		if (!raw['list'] || !raw['list'][_answer['status']]) return _answer

		// есть список и есть значение
		_answer['status'] = raw['list'][_answer['status']]
		_answer['status'] = this.localeFtc(_answer['status']).toLowerCase()

		// для отдельных случаев требуется лоадер
		if (raw[_field] === 'processing') _answer['loader'] = true

		return _answer
	},

	//=========================================================================
	// извлекает значение ячейки из списка "filters"
	//=========================================================================
	cellValueFromList: function(field, row, raw, methods) {
		if (row[field] === null || row[field] === undefined) return ''
		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list']) return row[field]

		let _value = ''
		let _list = raw['filters'][field]['list']

		if (typeof _list === 'object' && row[field] in _list)
			_value = raw['filters'][field]['list'][row[field]]
		else
			_value = 'Unknown'

		return this.methodsToValue(_value, methods)
	},

	//=========================================================================
	// извлекает статус пользователя
	//=========================================================================
	cellUserStatusValue: function(row, raw, methods) {
		// поля статуса пользователя
		let field = 'user_status'
		let fieldText = 'user_status_text'

		// если поля статуса нет
		if (!(field in row) || row[field] === undefined || row[field] === null) return ''

		// если есть текстовое поле - оно в приоритете
		if (fieldText in row && row[fieldText])
			return this.methodsToValue(row[fieldText], methods)

		// если у нас нет поля "filters" со списком - вернем просто значение
		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list']) return row[field]

		// найдем значение поля статуса в списке
		let _value = ''
		let _list = raw['filters'][field]['list']

		if (typeof _list === 'object' && row[field] in _list)
			_value = raw['filters'][field]['list'][row[field]]
		else
			_value = 'Unknown'

		return this.methodsToValue(_value, methods)
	},

	//=========================================================================
	// извлекает значение ячейки из массива объектов в "filters"
	//=========================================================================
	cellValueFromArrayObj: function(field, row, raw, methods) {
		if (row[field] === null || row[field] === undefined) return ''
		if (!raw['filters'] || !raw['filters'][field] || !raw['filters'][field]['list']) return row[field]

		let _value = ''
		let _list = raw['filters'][field]['list']
		if (typeof _list === 'object' && Array.isArray(_list))
		{
			_list.some((item) => {
				if ('id' in item && 'name' in item && item['id'] === row[field])
				{
					_value = item['name']
					return true
				}
			})
		}
		else _value = 'Unknown'

		return this.methodsToValue(_value, methods)
	},

	//=========================================================================
	// способ оплаты в финансах
	//=========================================================================
	cellOperationPayment_Text: function(row, raw, methods) {
		// получим текст
		let _text1 = Helper.cellValueFromArrayObj('payment_id', row, raw)
		let _text2 = row.operation_comment
		let _text3 = row.payer_name

		let _value1 = _text1 !== null && _text1 !== undefined ? String(_text1).trim() : ''
		let _value2 = _text2 !== null && _text2 !== undefined ? String(_text2).trim() : ''
		let _value3 = _text3 !== null && _text3 !== undefined ? String(_text3).trim() : ''

		if (_value1 === '' && row['payment_name']) _value1 = row['payment_name']

		let _value = _value1
		if (_value2 !== '')
		{
			if (_value !== '') _value += '<br>' + _value2
			else _value += _value2
		}

		if (_value3 !== '')
		{
			if (_value !== '') _value += '<br>' + _value3
			else _value += _value3
		}

		return this.methodsToValue(_value, methods)
	},

	cellOperationPayment_Url: function(row, raw) {
		let _url = '#'

		// если это клиент и операция не оплачена ("operation_status==0"), то ссылки на выбор способа оплаты
		if (row.operation_status !== null && row.operation_status !== undefined &&
			row.operation_status === 0 && store.state.user_type === 'client')
		{
			// если не может оплачивать - ничего не делаем
			if (!('can_pay' in row) || !row.can_pay)
				_url = '/operation/view/' + row.operation_id
			else
				// эта ссылка теперь перенесена в статус в виде кнопки
				// _url = '/operation/select/' + row.operation_id
				_url = '/operation/view/' + row.operation_id
		}
		else
		{
			_url = '/operation/view/' + row.operation_id
		}

		return _url
	},

	//=========================================================================
	// стоимость сервиса в типах
	//=========================================================================
	cellValueServiceTypeCost: function(row, raw, methods) {
		// значение по умолчанию
		let _value = {}
		// если указана стоимость
		if (row['service_type_cost'] !== null && row['service_type_cost'] !== undefined) _value['cost'] = String(this.FormatMoney2(row['service_type_cost']))
		// если указан период и справочник периодов
		if (row['service_type_period'] &&
			raw['filters']['service_type_period'] &&
			raw['filters']['service_type_period']['list'] &&
			raw['filters']['service_type_period']['list'][row['service_type_period']])
		{
			_value['period'] = this.localeFtc(String(raw['filters']['service_type_period']['list'][row['service_type_period']]))
		}

		// если указана еденица измерения
		if (row['service_type_for'])
		{
			_value['for'] = '1 ' + this.localeFtc(String(row['service_type_for']))
		}

		return _value
	},

	//=========================================================================
	// стоимость тарифа
	//=========================================================================
	cellValuePlanCost: function(row, raw) {
		let _value = {
			'cost': '0',
			'period': this.localeFtc('s/day')
		}

		if (row['plan_cost'] !== null && row['plan_cost'] !== undefined)
			_value['cost'] = String(this.FormatMoney2(row['plan_cost']))

		if (row['plan_period'] &&
			raw['filters']['plan_period'] &&
			raw['filters']['plan_period']['list'] &&
			raw['filters']['plan_period']['list'][row['plan_period']])
			_value['period'] = this.localeFtc(String(raw['filters']['plan_period']['list'][row['plan_period']]))

		return _value
	},

	//=========================================================================
	// формирует урл для АПИ
	//=========================================================================
	makeUrlForApi: function(url) {
		return Vue.APIServerUrl + url
	},

	//=========================================================================
	// возвращает номер локальной группы тарифов VDS на основе ID группы от АПИ
	//=========================================================================
	localGroupFromApiGroup: function(groupId) {
		let group = 1
		groupId = parseInt(groupId, 10)
		if (isNaN(groupId)) groupId = 0

		if (groupId)
		{
			// dev
			if (window.location.host === 'panel.test' || window.location.host === 'panel4dev.vdsina.ru' || window.location.host === 'cpdev.macloud.ru')
			{
				if (groupId === 5) group = 1
				else if (groupId === 12) group = 2
				else if (groupId === 19) group = 3
				else if (groupId === 17 || groupId === 18) group = 4
			}

			// prod
			if (window.location.host === 'cp.vdsina.ru' || window.location.host === 'cp.macloud.ru')
			{
				if (groupId === 1) group = 1
				else if (groupId === 3) group = 2
				else if (groupId === 4) group = 3
				else if (groupId === 7 || groupId === 8) group = 4
			}
		}

		return group
	},

	//=========================================================================
	// возвращает ID отдела отложенных
	//=========================================================================
	postPonseDepartmentId: function() {
		let _depId = -1

		// dev
		if (window.location.host === 'panel.test' ||
			window.location.host === 'panel4dev.vdsina.ru') {
			_depId = 13
		}

		if (window.location.host === 'cpdev.macloud.ru') {
			_depId = 1
		}

		// prod
		if (window.location.host === 'cp.vdsina.ru') {
			_depId = 14
		}

		if (window.location.host === 'cp.macloud.ru') {
			_depId = 10
		}

		return _depId
	},

	//=========================================================================
	// возвращает ID группы от АПИ по локальной группе тарифов VDS
	//=========================================================================
	apiGroupFromLocalGroup: function(group) {
		let groupId = null
		group = parseInt(group, 10)
		if (isNaN(group)) group = 0

		if (group)
		{
			// dev
			if (window.location.host === 'panel.test' || window.location.host === 'panel4dev.vdsina.ru' || window.location.host === 'cpdev.macloud.ru')
			{
				if (group === 1) groupId = 5
				else if (group === 2) groupId = 12
				else if (group === 3) groupId = 19
				else if (group === 4) groupId = [17, 18]
			}

			// prod
			if (window.location.host === 'cp.vdsina.ru' || window.location.host === 'cp.macloud.ru')
			{
				if (group === 1) groupId = 1
				else if (group === 2) groupId = 3
				else if (group === 3) groupId = 4
				else if (group === 4) groupId = [7, 8]
			}
		}

		return groupId
	},

	//=========================================================================
	// возвращает ID группы от АПИ по однойиз ID групп тарифов VDS
	//=========================================================================
	apiGroupFromOneGroup: function(id) {
		let groupId = null
		id = parseInt(id, 10)
		if (isNaN(id)) id = 0

		if (id)
		{
			// dev
			if (window.location.host === 'panel.test' || window.location.host === 'panel4dev.vdsina.ru' || window.location.host === 'cpdev.macloud.ru')
			{
				if ([17, 18].indexOf(id) > -1)
					groupId = [17, 18]
				else
					groupId = id
			}

			// prod
			if (window.location.host === 'cp.vdsina.ru')
			{
				if ([7, 8].indexOf(id) > -1)
					groupId = [7, 8]
				else
					groupId = id
			}

			// prod
			if (window.location.host === 'cp.vdsina.com' || window.location.host === 'cp.macloud.ru')
			{
				groupId = id
			}
		}

		return groupId
	},

	//=========================================================================
	// картинка для группы VDS
	//=========================================================================
	vdsGroupImage: function(row) {
		// если есть лого группы в ответе АПИ
		if (row && row.service_data && row.service_data.plangroup &&
			row.service_data.plangroup.image)
		{
			return Vue.APIServerUrl + row.service_data.plangroup.image
		}

		// смотрим в локальные переменны
		let path = '/static/img/vds/vds-'
		let group = '1'

		if (row && row.localGroupId)
			group = row.localGroupId
		else if (row && row.group_id)
			group = this.localGroupFromApiGroup(row.group_id)

		return path + group + '.png'
	},

	//=========================================================================
	// заголовок иконки группы VDS - название группы
	//=========================================================================
	vdsGroupImageTitle(row, data) {
		let title = ''

		// если есть название группы в ответе АПИ
		if (row && row.service_data && row.service_data.plangroup &&
			row.service_data.plangroup.name)
		{
			return row.service_data.plangroup.name
		}

		// смотрим в локальные переменны
		if (row && data &&
			row.group_id && data.filters && data.filters.group_id &&
			data.filters.group_id.list && data.filters.group_id.list.length)
		{
			data.filters.group_id.list.some(c => {
				if (c && c.id === row.group_id)
				{
					title = c.name
					return true
				}
			})
		}

		return title
	},

	//=========================================================================
	// получает данные "field" из service_data
	//=========================================================================
	cellValueFromServiceData: function(field, row) {
		// проверка
		if (row['service_data'] === null || row['service_data'] === undefined) return ''

		// template's url
		if (field === 'template:image')
		{
			if (row['service_data'] !== null && row['service_data'] !== undefined &&
				row['service_data']['template'] !== null && row['service_data']['template'] !== undefined &&
				row['service_data']['template']['image'] !== null && row['service_data']['template']['image'] !== undefined)
			{
				let _url = row['service_data']['template']['image']
				return Vue.APIServerUrl + (_url.charAt(0) === '/' ? _url : '/' + _url)
			}
		}

		// IP
		if (field === 'ip:ip')
		{
			if (row['service_data'] !== null && row['service_data'] !== undefined &&
				row['service_data']['ip'] !== null && row['service_data']['ip'] !== undefined &&
				row['service_data']['ip']['ip'] !== null && row['service_data']['ip']['ip'] !== undefined)
			{
				return row['service_data']['ip']['ip']
			}
		}
		// IP active
		if (field === 'ip:ip:active')
		{
			if (row['service_data'] !== null && row['service_data'] !== undefined &&
				row['service_data']['ip'] !== null && row['service_data']['ip'] !== undefined &&
				'active' in row['service_data']['ip'])
			{
				return row['service_data']['ip']['active']
			}
			else return true
		}

		// flag
		if (field === 'datacenter:country')
		{
			if (row['service_data'] !== null && row['service_data'] !== undefined &&
				row['service_data']['datacenter'] !== null && row['service_data']['datacenter'] !== undefined &&
				row['service_data']['datacenter']['country'] !== null && row['service_data']['datacenter']['country'] !== undefined)
			{
				return row['service_data']['datacenter']['country']
			}
			else return 'null'
		}

		// flag title
		if (field === 'datacenter:name')
		{
			if (row['service_data'] !== null && row['service_data'] !== undefined &&
				row['service_data']['datacenter'] !== null && row['service_data']['datacenter'] !== undefined &&
				row['service_data']['datacenter']['name'] !== null && row['service_data']['datacenter']['name'] !== undefined)
			{
				return this.localeFtc(row['service_data']['datacenter']['name'])
			}
		}

		// plan
		if (field === 'plan:data')
		{
			let _ram = ''
			let _cpu = ''
			let _disk = ''

			if (row['service_data'] &&
				row['service_data']['plan'] &&
				row['service_data']['plan']['data'])
			{
				// RAM
				if (row['service_data']['plan']['data']['ram'])
				{
					_ram = (row['service_data']['plan']['data']['ram']['total']
						? row['service_data']['plan']['data']['ram']['total']
						: row['service_data']['plan']['data']['ram']['value']) + ' ' +
						row['service_data']['plan']['data']['ram']['for'] + ' ' +
						this.localeFtc(row['service_data']['plan']['data']['ram']['title'])
				}

				// CPU
				if (row['service_data']['plan']['data']['cpu'])
				{
					_cpu = (row['service_data']['plan']['data']['cpu']['total']
						? row['service_data']['plan']['data']['cpu']['total']
						: row['service_data']['plan']['data']['cpu']['value']) + ' ' +
						row['service_data']['plan']['data']['cpu']['for'] + ' ' +
						this.localeFtc(row['service_data']['plan']['data']['cpu']['title'])
				}

				// DISK
				if (row['service_data']['plan']['data']['disk'])
				{
					_disk = (row['service_data']['plan']['data']['disk']['total']
						? row['service_data']['plan']['data']['disk']['total']
						: row['service_data']['plan']['data']['disk']['value']) + ' ' +
						row['service_data']['plan']['data']['disk']['for'] + ' ' +
						this.localeFtc(row['service_data']['plan']['data']['disk']['title'])
				}
			}

			return _ram + ' / ' + _cpu + ' / ' + _disk
		}

		// ответ по умолчанию
		return ''
	},

	//=========================================================================
	// форматирует деньги
	//=========================================================================
	FormatMoney: function(value) {
		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
	},

	FormatMoney2: function(money, places = 2, grp = ' ', del = '.') {
		// преобразование к типу
		let _money = money
		if (typeof money !== 'number') _money = Number(money)
		if (_money === null || _money === undefined || isNaN(_money)) return money

		// максимум 4 знака после запятой
		_money = parseFloat(_money.toFixed(4))

		// преобразование к строке
		let _str
		if (places < 0)
		{
			// требуется определения количества знаков из аргумента
			// лишние нули с конца уже убраны преобразованием к Number
			_str = String(_money)
		}
		// количество знаков строго задано
		else _str = String(_money.toFixed(places))

		// проверка
		if (_str.trim() === '') return ''

		// если это панель с маленькими числами (цены в центах)
		if (this.SmallAmounts)
		{
			// проверка на самый последний знак после запятой
			if (places >= 0 && _money !== 0)
			{
				// идем от максимального количества знаков после запятой
				_str = String(_money.toFixed(4))
				if (_str.slice(-1) === '0' && places < 4)
				{
					_str = String(_money.toFixed(3))
					if (_str.slice(-1) === '0' && places < 3)
					{
						_str = String(_money.toFixed(2))
						if (_str.slice(-1) === '0' && places < 2)
						{
							_str = String(_money.toFixed(1))
							if (_str.slice(-1) === '0' && places < 1)
							{
								_str = String(_money.toFixed(0))
							}
						}
					}
				}
			}
		}
		else
		{
			// проверка на ноль после округления
			if (places >= 0 && Number(_str) === 0 && _money !== 0)
			{
				// возможно округление дало ноль
				// пошагово увеличиваем количество знаков после запятой
				places++
				_str = String(_money.toFixed(places))

				if (Number(_str) === 0)
				{
					places++
					_str = String(_money.toFixed(places))

					if (Number(_str) === 0)
					{
						places++
						_str = String(_money.toFixed(places))

						if (Number(_str) === 0)
						{
							places++
							_str = String(_money.toFixed(places))
						}
					}
				}
			}
		}

		// получим массив, разбив строку по разделителю дроби
		let _parts = _str.split('.')

		// форматируем значение
		_str = _parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp)
		if (_parts[1] && _parts[1].length) _str += del + _parts[1]

		return _str
	},

	String2Money: function(money) {
		if (money === null || money === undefined) return ''
		if (typeof money !== 'string') return String(money)
		if (money.trim() === '') return ''

		// получим массив, разбив строку по разделителю дроби
		let _parts = money.split('.')

		// форматируем значение
		let _str = _parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
		if (_parts[1] && _parts[1].length)
		{
			let _dec = parseFloat('0.' + _parts[1])
			if (!isNaN(_dec) && _dec > 0)
			{
				_parts = String(_dec).split('.')
				if (_parts[1] && _parts[1].length)
					_str += '.' + _parts[1]
			}
		}

		return _str
	},

	Num2Money: function(money, digs) {
		if (typeof money !== 'number') money = Number(money)
		if (money === null || money === undefined || isNaN(money)) return money

		// получим массив, разбив строку по разделителю дроби
		money = String(money.toFixed(digs))
		let _parts = money.split('.')

		// форматируем значение
		let _str = _parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
		if (_parts[1] && _parts[1].length) _str += '.' + _parts[1]

		return _str
	},

	//=========================================================================
	// форматирует размеры в файтах
	//=========================================================================
	FormatBytes: function(bytes) {
		if (!bytes || bytes <= 0) return '0 Б'
		let k = 1000
		let dm = 1
		let sizes = ['main/traffic_b', 'main/traffic_kb', 'main/traffic_mb', 'main/traffic_gb', 'main/traffic_tb', 'main/traffic_pb', 'main/traffic_eb', 'ZB', 'YB']
		let i = Math.floor(Math.log(bytes) / Math.log(k))
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + this.localeFtc(sizes[i])
	},

	//=========================================================================
	// форматирует дату и время, формат смотри в плагине "fomater"
	//=========================================================================
	FormatDateTime: function(date, format = 'd.m.y H:M:S') {
		// проверка входного параметра: "2017-03-01"
		if (/^\d{4}-\d{2}-\d{2}$/.test(date))
		{
			// получим параметры
			let _date = date.split('-')

			// возвращаем результат
			return format
				.replace('d', _date[2])
				.replace('m', _date[1])
				.replace('Y', _date[0])
				.replace('y', _date[0].substr(2, 2))
				.replace('H', '')
				.replace('M', '')
				.replace('S', '')
		}

		// проверка входного параметра: "2017-03-01 23:59:59"
		if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date))
		{
			// получим параметры
			let _parts = date.split(/\s/)
			let _date = _parts[0].split('-')
			let _time = _parts[1].split(':')

			// возвращаем результат
			return format
				.replace('d', _date[2])
				.replace('m', _date[1])
				.replace('Y', _date[0])
				.replace('y', _date[0].substr(2, 2))
				.replace('H', _time[0])
				.replace('M', _time[1])
				.replace('S', _time[2])
		}

		return date
	},

	//=========================================================================
	// конвертирует дату в виде форматированной строки в объект Date
	//=========================================================================
	FormatedStrDate2Date(date, format) {
		// здесь будет строковая дата
		let _str = date

		// производим разбор значения если данные пришли не в нужном формате
		if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(date) && !/^\d{4}-\d{2}-\d{2}$/.test(date))
		{
			// определим разделитель - и в текстовом виде и для RegExp
			let _delimeter = ''
			let _expDelimeter = null
			if (format.indexOf('.') > 0)
			{
				_delimeter = '.'
				_expDelimeter = '\\.'
			}
			else if (format.indexOf('-') > 0)
			{
				_delimeter = '-'
				_expDelimeter = '-'
			}
			else if (format.indexOf('/') > 0)
			{
				_delimeter = '/'
				_expDelimeter = '\\/'
			}
			// формируем RegExp на основе заданного формата
			let _formatParts = format.split(_delimeter)
			let _exp = ''
			let _index = {}
			// обрабатываем каждую часть формата
			_formatParts.forEach((_key, _idx) => {
				if (_exp) _exp += _expDelimeter

				if (_key === 'd' || _key === 'm' || _key === 'y') _exp += '(\\d{2})'
				else if (_key === 'Y') _exp += '(\\d{4})'

				_index[_key] = _idx + 1
			})

			// разбиваем дату по частям
			let _match = null
			try {
				let _reg = new RegExp(_exp)
				_match = date.match(_reg)
				if (!_match) return null
			}
			catch (e) {
				return null
			}

			// проверка обязательных компонентов
			if (!_index['d'] || !_index['m']) return null
			if (!_index['Y'] && !_index['y']) return null

			// собираем в итоге дату в нужном нам формате
			_str = ''
			// год
			if (_index['Y']) _str += _match[_index['Y']]
			if (_index['y']) _str += String(1900 + _match[_index['y']])
			// разделитель
			if (_str) _str += '-'
			// месяц
			if (_index['m']) _str += _match[_index['m']]
			// разделитель
			if (_str) _str += '-'
			// день
			if (_index['d']) _str += _match[_index['d']]
		}

		// проверка входного параметра: "2017-03-01"
		if (/^\d{4}-\d{2}-\d{2}$/.test(_str)) _str = _str + ' 00:00:00'

		// проверка входного параметра: "2017-03-01 23:59:59"
		if (!/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_str)) return null

		// получим параметры
		let _parts = _str.split(/\s/)
		let _date = _parts[0].split('-')
		let _time = _parts[1].split(':')

		// возвращаем результат
		return new Date(
			parseInt(_date[0]),
			parseInt(_date[1]) - 1,
			parseInt(_date[2]),
			parseInt(_time[0]),
			parseInt(_time[1]),
			parseInt(_time[2])
		)
	},

	//=========================================================================
	// вычисляет количество лет с заданной даты (объекта типа Date)
	//=========================================================================
	calculateAge(birthday) {
		let ageDifMs = Date.now() - birthday.getTime()
		let ageDate = new Date(ageDifMs)
		let yearDif = ageDate.getUTCFullYear() - 1970
		if (yearDif < 0) yearDif = 0
		return yearDif
	},

	//=========================================================================
	// приводит заданное значене к Boolean
	//=========================================================================
	normalizeBooleanValue: function(value) {
		// если null или undefined
		if (value === null || value === undefined) return false
		// если тип уже нормальный
		if (typeof value === 'boolean') return value
		// если это строка
		if (typeof value === 'string')
		{
			// уберем пробелы и приведем к нижнему регистру
			value = String(value).trim().toLowerCase()

			// возвращаем значение
			if (value === 'yes' || value === 'true' || value === '+' || value === '1') return true
			if (value === 'no' || value === 'false' || value === '-' || value === '0' || value === '') return false
		}

		// преобразуем
		return Boolean(value)
	},

	//=========================================================================
	// убирает выделенный текст в браузере
	//=========================================================================
	removeBrowserSelectionText: function() {
		if (window.getSelection)
		{
			if (window.getSelection().empty)
			{
				// Chrome
				window.getSelection().empty()
			}
			else if (window.getSelection().removeAllRanges)
			{
				// Firefox
				window.getSelection().removeAllRanges()
			}
		}
		else if (document.selection)
		{
			// IE?
			document.selection.empty()
		}
	},

	//=========================================================================
	// копирует содержимое элемента в клипбоард
	//=========================================================================
	copyToClipboard(el) {
		if (document.body.createTextRange)
		{
			// IE
			let textRange = document.body.createTextRange()
			textRange.moveToElementText(el)
			textRange.select()
			textRange.execCommand('Copy')
			return true
		}
		else if (window.getSelection && document.createRange)
		{
			// non-IE
			let range = document.createRange()
			range.selectNodeContents(el)
			let sel = window.getSelection()
			sel.removeAllRanges()
			sel.addRange(range)
			try {
				document.execCommand('copy')
				return true
			} catch (err) {
			}
		}

		return false
	},

	//=========================================================================
	// поиск объекта внутри заданного объекта точно по имени
	//=========================================================================
	findObj: function(name, obj, crud)
	{
		if (obj === null || obj === undefined) return false
		if (typeof obj !== 'object') return false
		if (name in obj && obj[name])
		{
			// частные случаи
			if (crud !== 'email' || name !== 'email')
				return obj[name]
		}

		let fnd = false
		let i
		for (i in obj) if (obj.hasOwnProperty(i))
		{
			fnd = this.findObj(name, obj[i])
			if (fnd) return fnd
		}

		return false
	},

	//=========================================================================
	// случайное целое число в диапазоне, включая концы
	//=========================================================================
	getRandomInt: function(min, max) {
		return Math.floor(Math.random() * (max - min)) + min
	},

	//=========================================================================
	// проверяет - есть ли в строке хотя бы одна цифра
	//=========================================================================
	isStrHaveNum: function(str) {
		return /\d/g.test(str)
	},

	//=========================================================================
	// это число?
	//=========================================================================
	isNumeric: function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n)
	},

	//=========================================================================
	// проверяет на корректность email
	//=========================================================================
	validateEmail: function(email) {
		if (!email) return false

		// приводим к строке
		email = String(email).trim()

		// простые проверки
		if (email.length <= 0) return false
		if (email.indexOf('@') === -1) return false

		// сложная проверка
		// eslint-disable-next-line
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(email)
	},

	//=========================================================================
	// установка куки
	//=========================================================================
	setCookie(name, value, options) {
		options = options || {}
		let expires = options.expires

		if (typeof expires === 'number' && expires)
		{
			let d = new Date()
			d.setTime(d.getTime() + expires * 1000)
			expires = options.expires = d
		}
		if (expires && expires.toUTCString) options.expires = expires.toUTCString()

		value = encodeURIComponent(value)
		let updatedCookie = name + '=' + value

		for (var propName in options)
		{
			updatedCookie += '; ' + propName
			let propValue = options[propName]
			if (propValue !== true)
			{
				updatedCookie += '=' + propValue
			}
		}

		document.cookie = updatedCookie
	},

	//=========================================================================
	// получение куки
	//=========================================================================
	getCookie(name) {
		let matches = document.cookie.match(new RegExp(
			// eslint-disable-next-line
			'(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
		))
		return matches ? decodeURIComponent(matches[1]) : undefined
	},

	//=========================================================================
	// удаление куки
	//=========================================================================
	deleteCookie(name) {
		this.setCookie(name, '', {
			'expires': new Date(0),
			'path': '/',
			'domain': Vue.CookieDomain
		})
	},

	//=========================================================================
	// генерация пароля
	//=========================================================================
	generatePassword: function(length) {
		// если длина не задана - ставим значене по умолчанию
		if (!length || length < 1) length = 14

		// переменные
		let i
		let n
		let c = 'qQwWeErRtTyYuUipPaAsSdDfFgGhHjJkKLzZxXcCvVbBnNmM123456789qQwWeErRtTyYuUipPaAsSdDfFgGhHjJkKLzZxXcCvVbBnNmM123456789'
		let pass = ''

		// цикл - генерация "length" раз по одному символу
		for (i = 1; i <= length; i++)
		{
			// случайное число
			n = Math.floor(Math.random() * 100)
			// если нет в массиве такого символа (либо за пределами массива)
			if (n >= c.length || c[n] === undefined || c[n] === null)
			{
				// продолжим (*)
				continue
			}

			// все нормально, получили символ - добавим его в итоговую строку
			pass += c[n]
		}

		// мы можем получить строку меньшей длины из-за пропусков в (*)
		if (pass.length < length)
		{
			// рекурсивный вызов с требуемой длиной
			pass += this.generatePassword(length - pass.length)
		}

		// если нет ни одной цифры - добавим в случайное место, случайнцю цифру
		if (!this.isStrHaveNum(pass))
		{
			// добавим цифру
			n = this.getRandomInt(2, length - 2)
			pass = pass.substring(0, n) + this.getRandomInt(0, 9) + pass.substring(n + 1)
		}

		return pass
	},

	//=========================================================================
	// форматирование денег
	//=========================================================================
	Money2String(n, c, d, t) {
		c = isNaN(c = Math.abs(c)) ? 2 : c
		d = d === undefined ? '.' : d
		t = t === undefined ? ',' : t
		let s = n < 0 ? '-' : ''
		let i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)))
		let j = (j = i.length) > 3 ? j % 3 : 0

		return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '')
	},

	MoneyForPrint(value, rub = 'руб.', kop = 'коп.') {
		let _parts = value.split('.')
		let _str = _parts[0] + ' ' + rub
		if (_parts[1]) _str += ' ' + _parts[1] + ' ' + kop
		else _str += ' 00 ' + kop
		return _str
	},

	//=========================================================================
	// форматирование даты
	//=========================================================================
	RusDate2Date(value) {
		if (!/^\d{2}.\d{2}.\d{4}$/.test(value)) return value
		let _parts = value.split('.')
		return new Date(parseInt(_parts[2]), parseInt(_parts[1]) - 1, parseInt(_parts[0]))
	},

	//=========================================================================
	// преобразование строки с суммой в число
	//=========================================================================
	Str2Float(val) {
		// если значение не задано
		if (!val) return NaN

		// уберем все пробелы
		let str = val.replace(/ /g, '')

		// ищем запятые
		let m = str.match(/,/g)
		// если они есть и их больше 1
		if (m != null && m.length > 1) return NaN

		// ищем точки
		m = str.match(/\./g)
		// если они есть и их больше 1
		if (m != null && m.length > 1) return NaN

		// форматируем
		str = str.replace(',', '.')

		return parseFloat(str)
	},
	Str2Int(val) {
		// если значение не задано
		if (!val) return NaN

		// уберем все пробелы
		let str = val.replace(/ /g, '')

		// ищем запятые
		let m = str.match(/,/g)
		// если они есть и их больше 1
		if (m != null && m.length > 1) return NaN

		// ищем точки
		m = str.match(/\./g)
		// если они есть и их больше 1
		if (m != null && m.length > 1) return NaN

		return parseInt(str)
	},

	//=========================================================================
	// первая заглавная, остальные нет
	//=========================================================================
	toUpperCaseFirstSymbol(str) {
		if (!str) return ''
		let value = String(str).toLowerCase().trim()
		return value.charAt(0).toUpperCase() + value.slice(1)
	},

	//=========================================================================
	// просто меняет первую букву на заглавную
	//=========================================================================
	FirstSymbolToUpperAndLatin(str) {
		if (!str) return ''
		let value = String(str).replace(/[а-яА-ЯёЁ]/ig, '')
		return value.charAt(0).toUpperCase() + value.slice(1)
	},

	//=========================================================================
	// фильтруем кириллицу
	//=========================================================================
	onlyLatin(str) {
		if (!str) return ''
		return String(str).replace(/[а-яА-ЯёЁ]/ig, '')
	},

	//=========================================================================
	// фильтруем кириллицу
	//=========================================================================
	onlyRussia(str) {
		if (!str) return ''
		return String(str).replace(/[a-z]/ig, '')
	},

	//=========================================================================
	// преобразование списка шаблонов для VDS
	//=========================================================================
	prepareTemplateList(field) {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// проверка
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (!field || !field['list']) return

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// бежим по всем элементам списка
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		let _newList = {}
		let _images = {}

		field.list.forEach((item, idx, arr) => {
			if (item['id'] && item['name'] &&
				String(item['id']).length && String(item['name']).length)
			{
				// по умолчанию типа нет наименования и версии
				let _nm = false
				let _vr = false

				// получим название OS
				let _parts = item['name'].split(' ')
				for (let j = 0; j < _parts.length; j++)
				{
					// если это версия
					if (/^[0-9.-]+$/.test(_parts[j]))
					{
						_vr = _parts.slice(j).join(' ')
						break
					}
					else
					{
						// это не цифры - значит будем считать что это наименование
						if (!_nm) _nm = _parts[j]
						else _nm += ' ' + _parts[j]
					}
				}

				// если название получено
				if (_nm && _nm.length)
				{
					// форматируем его
					//_nm = Helper.toUpperCaseFirstSymbol(_nm)
					_nm = _nm.replace(/os/i, 'OS').replace(/bsd/i, 'BSD').replace(/server/i, 'Server').replace(/web/i, 'Web')

					// запоминаем версию
					item['version'] = _vr

					// создаем такое свойство в новом объекте
					if (!(_nm in _newList)) _newList[_nm] = []
					if (!(_nm in _images)) _images[_nm] = item['image']
					// запоминаем шаблон
					_newList[_nm].push(item)
				}
			}
		})

		/*
		// бежим по новому списку - ищем шаблоны с одной версией
		let _transformedList = {}
		for (let os in _newList)
		{
			// если версия одна
			if (_newList[os].length === 1)
			{
				// новый ключ
				let _nm = os
				// добавим версию если она есть (могут уже быть без версий вообще)
				if (_newList[os][0]['version']) _nm += ' ' + _newList[os][0]['version']
				// копируем
				_transformedList[_nm] = _newList[os]
				// отменяем версионность
				_transformedList[_nm][0]['version'] = false
				_images[_nm] = _newList[os][0]['image']
			}
			// если версий несколько - копируем их все
			else _transformedList[os] = _newList[os]
		}
		*/

		// меняем список на новый
		field['list'] = _newList
		// сохраняем картинки
		field['images'] = _images

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},

	//=========================================================================
	// Валидирует имя хоста по FQDN
	//=========================================================================
	validateHostnameForFQDN(hostname) {
		let hostExp = /^(?=.{1,254}$)((?=[a-z0-9-]{1,63}\.)(xn--+)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}$/i
		hostname = String(hostname).trim()
		if (hostname.length === 0) return false

		// если это корректный простой домен
		if (hostExp.test(hostname)) return true
		// а может это интернациональный домен?
		return domainRegex().test(punyCode.toASCII(hostname))
	},

	//=========================================================================
	// получение выделенного текста во всем документе
	//=========================================================================
	getSelectedTextDocument() {
		let t = ''
		if (window.getSelection)
		{
			t = window.getSelection().toString()
		}
		else if (document.getSelection)
		{
			t = document.getSelection().toString()
		}
		else if (document.selection)
		{
			t = document.selection.createRange().text
		}

		return t
	},

	//=========================================================================
	// получение выделенного текста внутри элемента
	//=========================================================================
	getSelectedTextWithin(el) {
		let selectedText = ''
		if (typeof window.getSelection !== 'undefined')
		{
			let sel = window.getSelection()
			let rangeCount

			if ((rangeCount = sel.rangeCount) > 0)
			{
				let range = document.createRange()
				for (let i = 0, selRange; i < rangeCount; ++i)
				{
					range.selectNodeContents(el)
					selRange = sel.getRangeAt(i)

					if (selRange.compareBoundaryPoints(range.START_TO_END, range) === 1 && selRange.compareBoundaryPoints(range.END_TO_START, range) === -1)
					{
						if (selRange.compareBoundaryPoints(range.START_TO_START, range) === 1)
						{
							range.setStart(selRange.startContainer, selRange.startOffset)
						}
						if (selRange.compareBoundaryPoints(range.END_TO_END, range) === -1)
						{
							range.setEnd(selRange.endContainer, selRange.endOffset)
						}
						selectedText += range.toString()
					}
				}
			}
		}
		else if (typeof document.selection !== 'undefined' && document.selection.type === 'Text')
		{
			let selTextRange = document.selection.createRange()
			let textRange = selTextRange.duplicate()

			textRange.moveToElementText(el)

			if (selTextRange.compareEndPoints('EndToStart', textRange) === 1 && selTextRange.compareEndPoints('StartToEnd', textRange) === -1)
			{
				if (selTextRange.compareEndPoints('StartToStart', textRange) === 1)
				{
					textRange.setEndPoint('StartToStart', selTextRange)
				}
				if (selTextRange.compareEndPoints('EndToEnd', textRange) === -1)
				{
					textRange.setEndPoint('EndToEnd', selTextRange)
				}
				selectedText = textRange.text
			}
		}

		return selectedText
	},

	//=========================================================================
	// меняет переводы строки на строку "<br>"
	//=========================================================================
	nl2br(str) {
		if (str === undefined || str === null || str === '') return ''
		return String(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>')
	},

	//=========================================================================
	// меняет: "&" => "&amp;", "<" => "&lt;", ">" => "&gt;"
	//=========================================================================
	escapeHtml(str) {
		return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
	},

	//=========================================================================
	// Обрамляет строку "searchString" в строки "replaceBefore" и "replaceAfter" в тексте "Text"
	//=========================================================================
	/* eslint-disable */
	markStringInText: function(searchString, Text, replaceBefore, replaceAfter) {
		// если строка поиска не задана
		if (searchString === null || searchString === undefined || searchString === '') return Text

		// маркируем только в примитивных типах
		let type = typeof Text
		if (type === 'object' || type === 'function') return Text
		let text = String(Text)

		// обрамление по умолчанию
		let replace_str_before = replaceBefore || '<strong class="w5-selected-text">'
		let replace_str_after = replaceAfter || '</strong>'

		// генерируем строку для RegExp - экранируем спецсимволы RegExp
		let findString = searchString.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")

		// далем обрамление и возвращаем текст
		return text.replace(new RegExp(findString, 'ig'), function(str, offset, s) {
			// нельзя метить внутри тега
			// например <a href="STR">а вот тут уже можно метить STR</a>
			// есть ли до найденой строки символ "<"
			let _before = s.substr(0, offset) + str
			let _reg = new RegExp('\<([^\>]*?)' + str + '$', 'ig')
			let _in_tag = _reg.test(_before)

			// да - искомое слово в теге, нельзя менять текст
			if (_in_tag) return str

			// все в порядке
			return replace_str_before + str + replace_str_after
		})
	},
	/* eslint-enable */

	//=========================================================================
	// форматирование сообщения тикета
	//=========================================================================
	formatTicketMessage(messageContent, fastSearch, needFtc = false) {
		// проверка
		if (!messageContent || messageContent === '') return messageContent
		if (needFtc) messageContent = this.localeFtc(messageContent)

		// 1) выдялем ссылки
		// уберем опасные символы
		let _txt1 = this.escapeHtml(messageContent)
		// ищем ссылки
		_txt1 = linkifyHtml(_txt1, {
			defaultProtocol: 'https',
			validate: {
				url: (value) => {
					return /^(http|ftp)s?:\/\//.test(value)
				}
			}
		})

		// 1.1) пропустим через nl2br
		_txt1 = this.nl2br(_txt1)

		// 2) находим цитаты - метим их тегом
		// для этого разобьем сначала текст на строки
		let _strings = _txt1.split('<br>')
		let _newStrings = []
		let _level = 0
		let _cnt = _strings.length
		// 2.1) теперь если строка начинается с символа ">" - обрамим в наш тег
		for (let _i = 0; _i < _cnt; _i++)
		{
			/* eslint-disable */
			// если есть в начале троки символ цитирования
			if (/^\s*\&gt;/i.test(_strings[_i]))
			{
				// если мы здесь - как минимум уровень первый
				_level = 1

				// шестой и более уровень
				if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 6
				// пятый уровень
				else if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 5
				// четвертый уровень
				else if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 4
				// третий уровень
				else if (/^\s*\&gt;(\s|\t)*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 3
				// второй уровень
				else if (/^\s*\&gt;(\s|\t)*\&gt;/i.test(_strings[_i])) _level = 2
				// это или первый уровень или шестой и больше
				else _level = 1

				// выводим соответствующий уровень
				_newStrings.push('<span class="w5-quoted-text-level-' + _level + '">' + _strings[_i] + '</span>')
			}
			// нет символа цитирования - это простой текст
			else
			{
				_newStrings.push(_strings[_i])
			}
			/* eslint-enable */
		}

		// 2.2) выделяем полученные цитаты в блоки если в них больше 10 строк
		let _beginBlock = false
		_cnt = _newStrings.length
		let _textWithQuotesBlock = []
		let _beginBlockRowIndex = 0
		let _l = 0
		for (let _i = 0; _i < _cnt; _i++)
		{
			// если это строка с цитированием
			if (_newStrings[_i].substr(0, 5) === '<span')
			{
				// если еще не начали блок
				if (!_beginBlock)
				{
					// сохранили строку - по умолчанию кнопка показа скрыта, а само цитирование показано
					_textWithQuotesBlock.push('<div class="toggle-quote-block-hided">' +
							Helper.localeFtc('main/show_quote') +
							'</div><div class="clearfix"></div><div class="quote-block">' + _newStrings[_i])
					// выставили призак начала блока
					_beginBlock = true
					// запомнили где у нас начало блока
					_beginBlockRowIndex = _l
					// увеличли новый счетчик
					_l++
				}
				else
				{
					// просто добавляем строку и увеличиваем счетчик
					_textWithQuotesBlock.push(_newStrings[_i])
					_l++
				}
			}
			else
			{
				// если начат блок с цитированием
				if (_beginBlock)
				{
					// сохраним строку
					_textWithQuotesBlock.push('</div>' + _newStrings[_i])
					// смотрим сколько строк получилось в блоке
					if ((_l - _beginBlockRowIndex) >= 10)
					{
						// строк больше 10 - нужно показать кнопку показа, и скрыть блок цитирования
						// показываем кнопку
						let _t = _textWithQuotesBlock[_beginBlockRowIndex].replace('<div class="toggle-quote-block-hided', '<div class="toggle-quote-block')
						// скрываем блок
						_t = _t.replace('<div class="quote-block">', '<div class="quote-block-hided">')
						// запоминаем все это
						_textWithQuotesBlock[_beginBlockRowIndex] = _t
					}
					// уберем признак начала блока
					_beginBlock = false
					// обнуляем индекс начала блока
					_beginBlockRowIndex = 0
					// увеличли новый счетчик
					_l++
				}
				else
				{
					// просто добавляем строку и увеличиваем счетчик
					_textWithQuotesBlock.push(_newStrings[_i])
					_l++
				}
			}
		}

		// 2.3) соберем обратно в текст
		let _txt2 = _textWithQuotesBlock.join('<br>')

		// 3) если задан текст быстрого поиска - выделяем его
		let _txt3 = _txt2
		if (fastSearch && fastSearch !== '')
		{
			// приводму строку поиска к тому же виду что и в тексте
			let _fnd = this.escapeHtml(fastSearch)
			// делаем поиск и отметку
			_txt3 = this.markStringInText(_fnd, _txt2)
		}

		// возвращаем результат
		return _txt3
	},

	//=========================================================================
	// получение расширения из имени файла
	//=========================================================================
	getFileExt(str) {
		// если в имени файла есть точка
		if (str.indexOf('.') > -1)
		{
			let _ext = str.split('.').pop()
			if (!_ext) _ext = 'file'
			return _ext
		}

		// так как нужно что то отображать - вернем такой тип
		return 'file'
	},

	//=========================================================================
	// формирует строку HTTP-параметров из объекта
	//=========================================================================
	simpleQueryStringFromObject(obj) {
		let str = []
		for (let p in obj) if (obj.hasOwnProperty(p))
		{
			str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
		}
		return str.join('&')
	},

	//=========================================================================
	// сравнение значений полей
	//=========================================================================
	arrayCompare(arr1, arr2, otherField) {
		if (!arr1 || !arr2) return false
		if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
		if (arr1.length !== arr2.length) return false

		for (let i = 0, l = arr1.length; i < l; i++)
		{
			// если это вложенные массивы
			if (arr1[i] instanceof Array && arr2[i] instanceof Array)
			{
				// проверяем их рекурсивно
				let _ans = this.arrayCompare(arr1[i], arr2[i])
				if (!_ans) return false
			}
			else
			{
				// получим данные по которым будет сравнимать
				let _val1 = arr1[i]
				if (typeof _val1 === 'object' && 'id' in _val1) _val1 = String(_val1['id'])
				let _val2 = arr2[i]
				if (typeof _val2 === 'object' && 'id' in _val2) _val2 = String(_val2['id'])
				// сравним
				if (String(_val1) !== String(_val2)) return false

				// если заданы дополнительные поля для сравнения
				if (otherField && otherField.length)
				{
					for (let j = 0; j < otherField.length; j++)
					{
						// val1
						if (typeof arr1[i] === 'object' && otherField[j] in arr1[i])
							_val1 = String(arr1[i][otherField[j]])
						else
							_val1 = null

						// val2
						if (typeof arr2[i] === 'object' && otherField[j] in arr2[i])
							_val2 = String(arr2[i][otherField[j]])
						else
							_val2 = null

						// сравнение
						if (String(_val1) !== String(_val2)) return false
					}
				}
			}
		}

		return true
	},

	//=========================================================================
	// конвертирует объект в массив (только первый уровень)
	//=========================================================================
	listAsArray(obj) {
		if (typeof obj !== 'object') return [obj]
		if (Array.isArray(obj)) return obj

		let _answer = []
		for (let p in obj) if (obj.hasOwnProperty(p))
		{
			let _item = { id: p }
			if (typeof obj[p] !== 'object') _item['name'] = obj[p]
			else
			{
				if (Array.isArray(obj[p]))
				{
					if (obj[p].length) _item['name'] = obj[p][0]
				}
				else
				{
					if (obj[p] && obj[p]['name']) _item['name'] = obj[p]['name']
				}
			}
			_answer.push(_item)
		}

		return _answer
	},

	//=========================================================================
	// заменяет теги на их кодовые аналоги (escape)
	//=========================================================================
	_replaceTag(tag) {
		let tagsToReplace = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;'
		}

		return tagsToReplace[tag] || tag
	},
	safe_tags_replace(str) {
		str = String(str)
		return str.replace(/[&<>"']/g, this._replaceTag)
	},

	//=========================================================================
	// выявляет - изменилась ли форма
	//=========================================================================
	isFormChanged(formData, crud, action, $store) {
		if (!formData) return false

		// частыне случаи
		// оплата клиентом
		if (crud === 'operation' && $store.state.user_type === 'client')
			// не нужно спрашивать в этой форме - форма всегда неизменна
			return false

		// получим все поля
		let _rows = formData['fields']
		if (!_rows || !Array.isArray(_rows)) return false

		// если есть активные загрузки файлов - сразу выдает положительный ответ
		if ($store.state.uploadFileCounter > 0) return true

		// бежим по всем полям
		let _answer = _rows.some(item => {
			let _found = false
			// смотрим только строки которые определены и являются массивами
			if (item && Array.isArray(item))
			{
				_found = item.some(field => {
					// если старое и текущее значение не совпадают - значит нашли изменения
					let _normValue = this.normValueForCheckChanges(field, crud, action, $store)

					if (Array.isArray(field['_oldValue']) || Array.isArray(_normValue))
					{
						// бывает текущее значение виде объекта
						if (typeof _normValue === 'object' && !Array.isArray(_normValue))
						{
							// конвертируем в массив
							let _arr = []
							for (let _p in _normValue) if (_normValue.hasOwnProperty(_p))
							{
								_arr.push(_p)
							}

							_normValue = _arr
						}

						if (!this.arrayCompare(field['_oldValue'], _normValue))
						{
							if ($store.state.isDebug)
								window.DEBUG.log(JSON.stringify({
									'field': field['_field_name'],
									'old': field['_oldValue'],
									'cur': _normValue
								}))
							return true
						}
					}
					// eslint-disable-next-line
					else if (field['_oldValue'] != _normValue)
					{
						// игнорим значения которые дополнительно инициализируются
						// шаблон в форме VDS
						if (!(this.crud === 'vds' && field['_field_name'] === 'template_id'))
						{
							if ($store.state.isDebug)
								window.DEBUG.log(JSON.stringify({
									'field': field['_field_name'],
									'old': field['_oldValue'],
									'cur': _normValue
								}))
							return true
						}
					}
				})
			}

			if (_found) return true
		})

		return _answer
	},

	//=========================================================================
	// нормализация значения для выявления изменений в форме
	//=========================================================================
	normValueForCheckChanges(field, crud, action, $store) {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// если данные некорректны
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (!field || !field['type']) return undefined

		return field['value'] !== null && field['value'] !== undefined ? field['value'] : field['_emptyValue']
	},

	//=========================================================================
	// монитор ретиновский?
	//=========================================================================
	isRetina() {
		let _el = document.getElementById('for-retina-detection')
		if (!_el) return false
		let _rect = _el.getBoundingClientRect()
		if (!_rect) return false
		return _rect.top > 0
	},

	//=========================================================================
	// есть ли значение в списке
	// Value - может быть строкой/числом, или объектом { id: value, name: text }
	// List - может быть массивом строк или объектов, а может быть объектом с
	//	ключами в виде значений
	//=========================================================================
	valueInList(Value, List) {
		// проверка
		if (!Value || !List || typeof List !== 'object') return false
		// если это пустой массив
		if (Array.isArray(List) && !List.length) return false

		// сначала получим значение
		let _value = null
		if (typeof Value === 'object')
		{
			if ('id' in Value) _value = Value['id']
		}
		else _value = Value
		if (!_value) return false

		// ищем в списке
		if (Array.isArray(List))
		{
			// список - это массив
			return List.some(item => {
				// элемент объект?
				if (typeof item === 'object')
				{
					if (String(item['id']) === String(_value)) return true
				}
				// элемент - простой тип
				else
				{
					if (String(item) === String(_value)) return true
				}
			})
		}
		else
		{
			// список - это объект с ключами значениями
			return (_value in List)
		}
	},

	//=========================================================================
	// проверка ИНН
	//=========================================================================
	checkINN(inn) {
		// если в строке есть не числа
		if (inn.match(/\D/)) return false

		// преобразуем в строку
		inn = String(inn)

		// преобразуем строку в массив символов
		inn = inn.split('')

		// проверка для ИНН в 10 знаков
		if (inn.length === 10)
		{
			let _control = String(((
				2 * inn[0] + 4 * inn[1] + 10 * inn[2] +
				3 * inn[3] + 5 * inn[4] + 9 * inn[5] +
				4 * inn[6] + 6 * inn[7] + 8 * inn[8]
			) % 11) % 10)

			return inn[9] === _control
		}
		// проверка для ИНН в 12 знаков
		else if (inn.length === 12)
		{
			let _control1 = String(((
				7 * inn[0] + 2 * inn[1] + 4 * inn[2] +
				10 * inn[3] + 3 * inn[4] + 5 * inn[5] +
				9 * inn[6] + 4 * inn[7] + 6 * inn[8] +
				8 * inn[9]
			) % 11) % 10)

			let _control2 = String(((
				3 * inn[0] + 7 * inn[1] + 2 * inn[2] +
				4 * inn[3] + 10 * inn[4] + 3 * inn[5] +
				5 * inn[6] + 9 * inn[7] + 4 * inn[8] +
				6 * inn[9] + 8 * inn[10]
			) % 11) % 10)

			return inn[10] === _control1 && inn[11] === _control2
		}

		return false
	},

	//=========================================================================
	// проверка ОГРН
	//=========================================================================
	checkOGRN(ogrn) {
		// если в строке есть не числа
		if (ogrn.match(/\D/)) return false

		// преобразуем в строку
		ogrn = String(ogrn)

		// для ОГРН в 13 знаков
		if (ogrn.length === 13)
		{
			return ogrn.slice(12, 13) === String(1 * ogrn.slice(0, -1) % 11).slice(-1)
		}
		// для ОГРН в 15 знаков
		else if (ogrn.length === 15)
		{
			return ogrn.slice(14, 15) === String(1 * ogrn.slice(0, -1) % 13).slice(-1)
		}

		return false
	},

	//=========================================================================
	// проверка БИК банка
	//=========================================================================
	checkBIC(bic) {
		bic = String(bic)
		return /^\d{9}$/.test(bic)
	},

	//=========================================================================
	// проверка коррсчета банка
	//=========================================================================
	checkKS(ks, bic) {
		ks = String(ks)
		bic = String(bic)

		if (!this.checkBIC(bic) || !/^\d{20}$/.test(ks))
			return false

		let bikKs = '0' + bic.slice(4, 6) + ks
		let checksum = 0
		let coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]

		for (let i in coefficients)
			checksum += coefficients[i] * (bikKs[i] % 10)

		if (checksum % 10 === 0)
			return true

		return false
	},

	//=========================================================================
	// проверка расчетного счета в банке
	//=========================================================================
	checkRS(rs, bic) {
		rs = String(rs)
		bic = String(bic)

		if (!this.checkBIC(bic) || !/^\d{20}$/.test(rs))
			return false

		let bikRs = bic.slice(-3) + rs
		let checksum = 0
		let coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]

		for (let i in coefficients)
			checksum += coefficients[i] * (bikRs[i] % 10)

		if (checksum % 10 === 0)
			return true

		return false
	},

	//=========================================================================
	// получить тримную строку
	//=========================================================================
	toTrimString(str) {
		if (str === undefined || str === null) return ''
		return String(str).trim()
	},

	//=========================================================================
	// проверка прав
	//=========================================================================
	verifyPermissions(userRole, currentRoute) {
		if (!userRole || !userRole.permissions || !userRole.permissions.length ||
			!currentRoute || !currentRoute.path)
			return false

		return userRole.permissions.some(curdAction => {
			if (currentRoute.path.indexOf(curdAction) > 0)
				return true
		})
	},

	//=========================================================================
	// сортировка буквенно-числовая (аналог natsort)
	//=========================================================================
	naturalCompare(a, b) {
		let ax = []
		let bx = []

		a.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { ax.push([$1 || Infinity, $2 || '']) })
		b.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { bx.push([$1 || Infinity, $2 || '']) })

		while (ax.length && bx.length)
		{
			var an = ax.shift()
			var bn = bx.shift()
			var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1])
			if (nn) return nn
		}

		return ax.length - bx.length
	},

	naturalCompareObjectField(fieldName, direction = 1) {
		return function(a, b) {
			let ax = []
			let bx = []

			a[fieldName].replace(/(\d+)|(\D+)/g, function(_, $1, $2) { ax.push([$1 || Infinity, $2 || '']) })
			b[fieldName].replace(/(\d+)|(\D+)/g, function(_, $1, $2) { bx.push([$1 || Infinity, $2 || '']) })

			while (ax.length && bx.length)
			{
				var an = ax.shift()
				var bn = bx.shift()
				var nn
				if (direction > 0)
					nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1])
				else
					nn = (bn[0] - an[0]) || bn[1].localeCompare(an[1])
				if (nn) return nn
			}

			if (direction > 0)
				return ax.length - bx.length
			else
				return bx.length - ax.length
		}
	},

	//=========================================================================
	// валидация IP-адреса
	//=========================================================================
	validateIPv4(ip) {
		let blocks = ip.split('.')
		if (blocks.length !== 4) return false

		return blocks.every(block => {
			let intVal = parseInt(block, 10)
			if (isNaN(intVal)) return false

			return intVal >= 0 && intVal <= 255
		})
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
export default Helper
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/helper/helper.js